import React from "react";
import {Badge, Card, CardBody, Col, Container, Row} from "shards-react";
import PageTitle from "../components/common/PageTitle";
import hit from './../utils/Hits';
import OWN_GAMES from './../data/ownGames';
import dobyvatelLogo from "./../images/dobyvatel.png";

class DobyvatelPage extends React.Component {


    constructor() {
        super();

        this.openDobyvatel = this.openDobyvatel.bind(this);
    }


    openDobyvatel() {
      hit(OWN_GAMES.DOBYVATEL);
      window.open(`https://hernizona.online/dobyvatel?session=${Math.random()}`, "_blank");
    }

    componentDidMount() {
      this.openDobyvatel();
    }

    render() {
        return (
            <Container fluid className="main-content-container px-4">
                <Row noGutters className="page-header py-4">
                    <PageTitle sm="4" title="Hra Dobyvatel" subtitle="Hry"
                               className="text-sm-left"/>
                </Row>

                <Row>
                    <Col lg="3" md="6" sm="12" className="mb-4" key={'dobyvatel2026'}>
                        <Card small className="card-post card-post--1">
                            <div
                                className="card-post__image"
                                style={{
                                    backgroundImage: `url(${dobyvatelLogo})`,
                                    backgroundRepeat: 'no-repeat',
                                    backgroundPosition: 'center',
                                    backgroundSize: 'contain',
                                    minHeight: '15rem'
                                }}
                            >
                                <Badge
                                    pill
                                    className={`card-post__category bg-dark`}
                                >
                                    hodnocení 5
                                </Badge>
                            </div>
                            <CardBody>
                                <h5 className="card-title" onClick={this.openDobyvatel}>
                    <span className="text-fiord-blue">
                      Dobyvatel
                    </span>
                                    &nbsp;&nbsp;&nbsp;
                                    <span style={{float: 'right'}}
                                          className="mb-2 mr-1 btn btn-success">
                      Hrát
                    </span>
                                </h5>

                            </CardBody>
                        </Card>
                    </Col>

                </Row>


            </Container>
        );
    }
}

export default DobyvatelPage;
